var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.862 5.035a7.5 7.5 0 0 1 7.769 1.599 7.5 7.5 0 0 1 1.958 3.106h.637a4.91 4.91 0 1 1 0 9.819H9.469a7.5 7.5 0 0 1-6.733-4.192A7.5 7.5 0 0 1 6.862 5.035m3.871.864A6.3 6.3 0 0 0 4.486 8.21 6.296 6.296 0 0 0 9.47 18.358h7.757a3.71 3.71 0 0 0 3.709-3.709 3.71 3.71 0 0 0-3.71-3.708H16.14a.6.6 0 0 1-.581-.45 6.29 6.29 0 0 0-4.826-4.592"
  })));
};
export default SvgCloud;